import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import { fetchOrder } from "../../../store/action/orderAction";
import imageDefault from '../../../assets/images/svg/ic-image-default.svg';
import { formatPrice } from "../../../services/helpers/Helper";
import NotFound from "./not-found";
import useQuery from "../../shared/Hooks/useQuery";
import icon from '../../../assets/images/svg/cancel.svg';

const PaymentResult = (props) => {
    const { fetchOrder, order } = props;
    const query = useQuery();
    const [isLoad, setIsLoad] = useState(true);
    const [isOrder, setIsOrder] = useState(false);

    const getOrderField = () => {
        return ['order_id', 'orderId', 'vnp_TxnRef'];
    }

    const getOrderId = () => {
        let orderId = '';
        getOrderField().map((f) => {
            if (!!query[f]) {
                orderId = query[f];
            }
        });
        return orderId;
    }

    useEffect(() => {
        const orderId = getOrderId();

        if (!!orderId) {
            fetchOrder(orderId)
                .finally(() => {
                    setIsLoad(false)
                    setIsOrder(true)
                });
        }
    }, [getOrderId()])

    return (
        <React.Fragment>
            {isOrder ?
                <div className="payment-container">
                    <div className=" flexbox">
                        <div className="content">
                            <div className="wrap">
                                <div className="sidebar">
                                    <div className="sidebar-content">
                                        <div className="order-summary order-summary-is-collapsed">
                                            <h2 className="visually-hidden">Thông tin đơn hàng</h2>
                                            <div className="order-summary-sections">
                                                <div className="order-summary-section order-summary-section-product-list"
                                                    data-order-summary-section="line-items">
                                                    <table className="product-table">
                                                        <thead>
                                                            <tr>
                                                                <th scope="col"><span className="visually-hidden">Hình ảnh</span></th>
                                                                <th scope="col"><span className="visually-hidden">Mô tả</span></th>
                                                                <th scope="col"><span className="visually-hidden">Số lượng</span></th>
                                                                <th scope="col"><span className="visually-hidden">Giá</span></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {order.orderProducts.map((item, index) => {
                                                                return (
                                                                    <tr className="product" key={index}>
                                                                        <td className="product-image">
                                                                            <div className="product-thumbnail">
                                                                                <div className="product-thumbnail-wrapper">
                                                                                    <img className="product-thumbnail-image" alt={item.product_name} src={imageDefault} />
                                                                                </div>
                                                                                <span className="product-thumbnail-quantity" ariaHidden="true">
                                                                                    {formatPrice(item.quantity)}
                                                                                </span>
                                                                            </div>
                                                                        </td>
                                                                        <td className="product-description">
                                                                            <span className="product-description-name order-summary-emphasis">
                                                                                {item.product_name}
                                                                            </span>
                                                                            <span className="product-description-variant order-summary-small-text">
                                                                            </span>
                                                                        </td>
                                                                        <td className="product-quantity visually-hidden">{item.quantity}</td>
                                                                        <td className="product-price">
                                                                            <span className="order-summary-emphasis">{formatPrice(item.quantity * item.product_price)} ₫</span>
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            })}
                                                        </tbody>
                                                    </table>
                                                </div>

                                                <div className="order-summary-section order-summary-section-total-lines payment-lines"
                                                    data-order-summary-section="payment-lines">
                                                    <table className="total-line-table">
                                                        <thead>
                                                            <tr>
                                                                <th scope="col"><span className="visually-hidden">Mô tả</span></th>
                                                                <th scope="col"><span className="visually-hidden">Giá</span></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr className="total-line total-line-subtotal">
                                                                <td className="total-line-name">Tạm tính</td>
                                                                <td className="total-line-price">
                                                                    <span className="order-summary-emphasis" data-checkout-subtotal-price-target="15000000">
                                                                        {formatPrice(order.grand_total)} ₫
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                            <tr className="total-line total-line-shipping">
                                                                <td className="total-line-name">Phí vận chuyển</td>
                                                                <td className="total-line-price">
                                                                    <span className="order-summary-emphasis" data-checkout-total-shipping-target="0">
                                                                        {formatPrice(order.shipping)} ₫
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                        <tfoot className="total-line-table-footer">
                                                            <tr className="total-line">
                                                                <td className="total-line-name payment-due-label">
                                                                    <span className="payment-due-label-total">Tổng cộng</span>
                                                                </td>
                                                                <td className="total-line-name payment-due">
                                                                    <span className="payment-due-currency">VND</span>
                                                                    <span className="payment-due-price">
                                                                        {formatPrice(order.grand_total)} ₫
                                                                    </span>
                                                                    <span className="checkout_version" data_checkout_version="0">
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        </tfoot>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="main">
                                    <div className="main-header">

                                        <h1 className="logo-text">{order.campaign_name}</h1>

                                    </div>
                                    <div className="main-content">
                                        <div>
                                            <div className="section">
                                                <div className="os-header-heading">
                                                    <h2 className="os-header-title">
                                                        Đơn hàng: #{order.reference_code}
                                                    </h2>
                                                </div>
                                            </div>
                                            <div className="section thank-you-checkout-info">
                                                <div className="section-content">
                                                    <div className="content-box">
                                                        <div className="content-box-row content-box-row-padding content-box-row-no-border">
                                                            <h2>Thông tin thanh toán</h2>
                                                        </div>
                                                        <div className="content-box-row content-box-row-padding">
                                                            <div className="section-content">
                                                                <div className="section-content-column">
                                                                    {order.payment_status == 1 ?
                                                                        <div className="inline-block">
                                                                            <p style={{
                                                                                backgroundColor: '#0939bb', borderColor: '#6790ff',
                                                                                color: '#e5efff', padding: '5px', borderRadius: '10px'
                                                                            }}>
                                                                                Thanh toán thành công
                                                                            </p>
                                                                        </div>
                                                                        :
                                                                        <div className="inline-block">
                                                                            <p style={{
                                                                                backgroundColor: '#ff563033', borderColor: '#ffb1c2',
                                                                                color: '#ef0032', padding: '5px', borderRadius: '10px'
                                                                            }}>
                                                                                Chưa hoàn thành thanh toán
                                                                            </p>
                                                                        </div>
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="content-box-row content-box-row-padding content-box-row-no-border">
                                                            <h2>Thông tin giao hàng</h2>
                                                        </div>
                                                        <div className="content-box-row content-box-row-padding">
                                                            <div className="section-content">
                                                                <div className="section-content-column">
                                                                    <p><b>Người nhận: </b>{order.shipping_full_name}</p>
                                                                    <p><b>Số điện thoại: </b>{order.shipping_phone}</p>
                                                                    <p><b>Địa chỉ:</b></p>
                                                                    <p>
                                                                        {order.shipping_address}
                                                                        <br />
                                                                        {order.shipping_ward_name}
                                                                        <br />
                                                                        {order.shipping_district_name}
                                                                        <br />
                                                                        {order.shipping_province_name}
                                                                        <br />
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                :
                <div className="cart-container">
                    <div className="content-error">
                        <img src={icon} />
                        <h4>Thanh toán thất bại</h4>
                        <p>Vui lòng trở về trang thanh toán để thử lại.</p>
                    </div>
                </div>
            }

        </React.Fragment>
    )
}

const mapStateToProps = (state) => {
    const { order } = state;
    return {
        order
    };
};

export default connect(mapStateToProps, {
    fetchOrder
})(PaymentResult)